// extracted by mini-css-extract-plugin
export default {"userSmallData":"styles_userSmallData__vN3Cz","text":"styles_text__5Oj9v"};